import { render } from "./Presentation.vue?vue&type=template&id=efede22c&scoped=true"
import script from "./Presentation.vue?vue&type=script&lang=ts"
export * from "./Presentation.vue?vue&type=script&lang=ts"

import "./Presentation.vue?vue&type=style&index=0&id=efede22c&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-efede22c"

export default script